module.exports = __webpack_public_path__ + "img/ECU_for_Nissan_Leaf5.032bc3be.jpg";